/**
 Project	IAM - Validation

 @file 	    admin-org.model.ts
 @author  	Martin Tazlari <martin.tazlari@ictvs.ch>
 @copyright © 2018, ICT-vs. All rights reserved.
 **/

export class TaggedService {
  userOid: string;
  serviceOid: string;
  baliseId: number;
  date: Date;
}

export const BALISETYPE = {
  None: 0,
  Pinned: 1,
  Hidden: 2,
} as const;
